import { random, padStart, split } from 'lodash';
import React from 'react';
import client from '../api/client';

/*  2회이상 재사용되는 공통함수는 여기다 넣자 JP            */
/*  global 공통 및 section별 공통은 주석으로 잘 나눠놓자    */


/*##         ##*/
/*## Global  ##*/
/*##         ##*/

/* 숫자포맷(세자리콤마) */
export const FormatNumber = (val) =>{
    return Number(val.toFixed(1)).toLocaleString()
}

/* 금액 표시 - 스타일 지정필요시 사용  : FormatNumber 사용 */
/* 폰트크기, 색상, 굵기, prefix, 단위(unit, postfix), + 아닌경우(0인경우) 표시값. 숫자값의 font-family 지정가능(디폴트 있음) */
export const showAmount = (props1) => {
    /* 디폴트 지정 */
    const defaultProps = {wrapper:"", fvWrapper:"", fontSize:"16px", prefix:"", color:"#111", weight: "500", falseVal:"", unit:"원", fontFamily: "Montserrat, sans-serif"}

    const props = {...defaultProps,...props1}
    const numStyle ={
        fontSize:props.fontSize,
        color: props.color,
        fontWeight: props.weight,
        fontFamily: props.fontFamily,
        marginRight: props.marginRight?props.marginRight:"0",
        marginLeft: props.marginLeft?props.marginLeft:"0",
        marginTop: props.marginTop?props.marginTop:"0",
        marginBottom: props.marginBottom?props.marginBottom:"0"
    };
    const unitStyle={
        fontSize:props.unitFontSize?props.unitFontSize:props.fontSize,
        color: props.unitColor?props.unitColor:props.color,
        fontWeight:props.unitWeight?props.unitWeight:props.weight,
        fontFamily: props.unitFontFamily?props.unitFontFamily:props.fontFamily};
    const fvStyle={
        fontSize:props.fvFontSize?props.fvFontSize:props.fontSize,
        color: props.fvColor?props.fvColor:props.color,
        fontWeight:props.fvWeight?props.fvWeight:props.weight,
        fontFamily: props.fvFontFamily?props.fvFontFamily:props.fontFamily,
        marginTop: props.marginTop?props.marginTop:"0",
        marginBottom: props.marginBottom?props.marginBottom:"0",
    };
    const prefixStyle={
        fontSize:props.pfFontSize?props.pfFontSize:props.fontSize,
        color: props.pfColor?props.pfColor:props.color,
        fontWeight:props.pfWeight?props.pfWeight:props.weight,
        fontFamily: props.pfFontFamily?props.pfFontFamily:props.fontFamily,
        marginRight: props.pfMarginRight?props.pfMarginRight:"0",
        marginLeft: props.pfMarginLeft?props.pfMarginLeft:"0"
    }
    if (props.amount > 0) {
        return (<div className={props.wrapper}>
            <span style={prefixStyle}>{props.prefix}</span><span style={numStyle}>{FormatNumber(props.amount)}</span><span style={unitStyle}>{props.unit}</span></div>)
    } else {
        return (<div className={props.fvWrapper} style={fvStyle}>{props.falseVal}</div>);
    }
}

if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
        'use strict';
        if (typeof start !== 'number') {
            start = 0;
        }

        if (start + search.length > this.length) {
            return false;
        } else {
            return this.indexOf(search, start) !== -1;
        }
    };
}

export const parseQueryString = (query=null, delimiter="||") => {
    /* parse query string and convert values to array if needed & also uridecode values if encoded */
    let parsed = {}
    !!query&&query.substr(1).split("&")
      .forEach(o=>{
          const p = !!o&&o.split("=").map(oo=>decodeURIComponent(oo))
          if(!!p[0]) {
              parsed[p[0]] = p[1].includes(delimiter) ? p[1].split(delimiter).map(o=>(isNaN(o) ? o : (o.isInteger ? parseInt(o) : parseFloat(o)))) : (isNaN(p[1]) ? p[1] : (p[1].isInteger ? parseInt(p[1]) : parseFloat(p[1])));
          }
      })
    return parsed;
}

export const buildQueryString = (param, delimiter="||") => {
    // omit if empty string/null or length 0 array
    let queryArr = [];
    for( const keyval in param) {
        const val = Array.isArray(param[keyval])?(param[keyval].length?param[keyval].join(delimiter):""):param[keyval];
        (!!val)&&queryArr.push(`${keyval}=${val}`)
    }

    return queryArr.join("&")
}

// const URIDecode = (x) => {
//     return (decodeURI(x) !== decodeURIComponent(x))?decodeURIComponent(x):x;
// }

/* 쿠키 설정 (간단한 경우만 쓰고, 나머지는 localStorage로 가자 - TODO */
export const setCommonCookie = (name, value, expire, term = 'd') => {
    let exipreDate = new Date();
    const terms = {
        sec: 1000,
        min: 60*1000,
        h: 60*60*1000,
        d: 24*60*60*1000,
        w: 7*24*60*60*1000,
        m: 30*24*60*60*1000,  // assume 1 month is 30days
    }

    exipreDate.setTime(exipreDate.getTime()+ expire*terms[term]);

    document.cookie = name + '=' + escape(value) + '; path=/; expires=' + exipreDate.toGMTString() + ';';
}

export const getCommonCookie = (name=null) => {
    const cookieValue = window.document.cookie.split(";").map(o=> {
        let a = o.split('=');
        return {name:a[0].trim(), value:a[1].trim()};
    })
    return !!name?cookieValue.find(o=>o.name===name):cookieValue;
}

export const logging = (location) => {
    return client.post('/meta/log', { location: location, referrer: document.referrer })
}

export const isEmptyObject = (obj) =>{
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}
export const lPad = (padlen, num, char="0") => {
    const padString = new Array(padlen + 1).join( char );
    return (padString+num).slice(-Math.max(padlen,num.toString().length));
}

// export {FormatNumber, showAmount, setCommonCookie, getCommonCookie, parseQureyString, buildQueryString, logging, lPad};
